angular.module 'zc.commonApi'

.factory 'installationApi', ($resource, Api, $q, $stateParams) ->
  _project_id = $stateParams.projectId

  _baseapi = $resource Api.path("/api/projects/:project_id/installation/:id"),
    project_id: '@project_id'
    id: '@id'

  _urlapi = $resource Api.path("/api/projects/:project_id/installation/:id/set"),
    project_id:  '@project_id'
    id: '@id'
    step: '@step'

  getDelegate = (param)->
    param['project_id'] = _project_id
    d = $q.defer()
    _baseapi.get param
    .$promise.then (res) ->
      d.resolve res.result
    , (err) ->
      d.reject err
    d.promise

  setDelegate = (param)->
    param['project_id'] = _project_id
    _postm = new _urlapi param
    d = $q.defer()
    _postm.$save().then (res) ->
      d.resolve res.result
    d.promise

  service = 
    getTrackingStatus: ->
      getDelegate 
        id: 'statelist'
    getTrackingState: (state) ->
      getDelegate
        id: 'status'
        state: state
    getTrackingPageLists: ->
      getDelegate
        id: 'trackingpagelist'
    getTrackingPageTypes: ->
      getDelegate
        id: 'trackingpagetype'
    setTrackingPage: (urlobj) ->
      setDelegate
        id: 'trackingpage'
        url: urlobj
    deleteTrackingPage: (urlobj) ->
      setDelegate
        id: 'deletetrackingpage'
        url: urlobj
    getConversionStatus: ->
      getDelegate
        id: 'conversionstateus'
    getSettingDomain:->
      getDelegate
        id: 'settingdomain'
    setSettingDomain: (domain)->
      setDelegate
        id: 'settingdomain'
        domain: domain
    deleteSettingDomain: (domain) ->
      setDelegate
        id: 'deletedomain'
        domain: domain
    getSiteAnalysisList: ->
      getDelegate
        id: 'siteanalysislist'
    getSiteAnalysisState: ->
      getDelegate
        id: 'siteanalysisstate'
    putSiteAnalysis: (site)->
      setDelegate
        id: 'siteanalysis'
        site: site
    getIpAddresss: ->
      getDelegate
        id: 'ipaddress'
    setIpAddress:(address) ->
      setDelegate
        id: 'ipaddress'
        address: address
    deleteIpAdress: (address) ->
      setDelegate
        id: 'deleteipaddress'
        address: address
    putinviteuser: (mail) ->
      setDelegate
        id: 'inviteuser'
        mail: mail
  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/installation_service.js.coffee